import { render } from "./DialogFullImage.vue?vue&type=template&id=f9837df2&scoped=true"
import script from "./DialogFullImage.vue?vue&type=script&lang=js"
export * from "./DialogFullImage.vue?vue&type=script&lang=js"

import "./DialogFullImage.vue?vue&type=style&index=0&id=f9837df2&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9837df2"]])

export default __exports__